const actions = {
  SET_SERVICE_ITEM: "SET_SERVICE_ITEM",
  SET_SERVICE_ITEM_VALUE: "SET_SERVICE_ITEM_VALUE",
  SERVICE_IS_SUBMITTING: "SERVICE_IS_SUBMITTING",
  SERVICE_SUBMIT_FAILED: "SERVICE_SUBMIT_FAILED",
  SET_SERVICE_DETAIL_ADMIN: 'SET_SERVICE_DETAIL_ADMIN',
  LOAD_SERVICES_ADMIN: 'LOAD_SERVICES_ADMIN'
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/admin/services.js